import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { teamsAPI } from '../services/api';
import SEOHead from '../components/SEOHead';

const Teams = () => {
  const { data: teams = [], isLoading } = useQuery({ queryKey: ['teams'], queryFn: () => teamsAPI.getAll().then((r) => r.data) });

  if (isLoading) return <div className="p-8 text-center">Loading...</div>;

  return (
    <>
      <SEOHead
        title="2026 FIFA World Cup Teams - WorldCup Fan Planner"
        description="Qualified nations, groups, and FIFA rankings for the 2026 FIFA World Cup in North America."
      />
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Teams</h1>
      <p className="text-gray-600 dark:text-gray-400 mb-6">Qualified and participating nations</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {teams.map((t) => (
          <div key={t.id} className="p-4 rounded-xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-amber-200 dark:hover:border-amber-800/50 transition-all">
            <div className="font-bold text-lg">{t.name}</div>
            <div className="text-sm text-gray-500 dark:text-gray-400">Group {t.group} • FIFA #{t.fifa_ranking || '-'}</div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default Teams;
